//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable import/no-cycle */
import { useUtils } from '@core/libs/i18n'
import { openTab } from '@core/utils'
import themeConfig from '@themeConfig'
import store from '@/store'

export default {
  setup() {
    const { t } = useUtils()

    const onBackToHome = () => {
      store.dispatch('auth/logoutAction')
      openTab('https://www.fanaty.com/')
    }

    return {
      appName: themeConfig.app.name,
      appLogo: themeConfig.app.logo,

      t,
      onBackToHome,
    }
  },
}
